


































































































































































































































import { computed, defineComponent, PropType, ref } from '@vue/composition-api';
import {
  IInvoice,
  IInvoiceItem,
  InvoiceStateEnum,
  ITax,
  PaymentPlanAmountTypeEnum
} from '@/models';
import {
  useDeleteInvoiceItem,
  useFetchInvoiceItems,
  useTaxTextVisuals
} from '@/composable/invoice';

import ErrorAlert from '../common/ErrorAlert.vue';
import InvoiceDetailSummaryItemsTableItems from '@/components/invoice/InvoiceDetailSummaryItemsTableItems.vue';
import InvoiceItemDialog from '@/components/invoice/InvoiceItemDialog.vue';
import ConfirmationDialog from '@/components/common/ConfirmationDialog.vue';

export default defineComponent({
  name: 'InvoiceDetailSummaryItemsTable',
  components: {
    InvoiceDetailSummaryItemsTableItems,
    ErrorAlert,
    InvoiceItemDialog,
    ConfirmationDialog
  },
  props: {
    invoice: {
      type: Object as PropType<IInvoice>,
      required: true
    }
  },
  setup(props) {
    const dialog = ref(false);
    const selectedInvoiceItem = ref<IInvoiceItem | null>(null);

    function openInvoiceItemDialog(invoiceItem?: IInvoiceItem) {
      dialog.value = true;
      selectedInvoiceItem.value = invoiceItem ?? null;
    }

    const {
      isLoading: deleteInProgress,
      error: deleteError,
      mutate: deleteInvoiceItem
    } = useDeleteInvoiceItem(props.invoice.id!);

    const deleteDialog = ref(false);
    function openDeleteInvoiceItemDialog(invoiceItem: IInvoiceItem) {
      selectedInvoiceItem.value = invoiceItem;
      deleteDialog.value = true;
    }

    function closeDialog() {
      deleteDialog.value = false;
    }

    function removeInvoiceItem(invoiceItem: IInvoiceItem) {
      deleteInvoiceItem(invoiceItem.id!, {
        onSuccess: () => {
          closeDialog();
        }
      });
    }

    function clearAllErrors() {
      fetchError.value = null;
    }

    const {
      invoiceItems,
      error: fetchError,
      isLoading: isFetchLoading
    } = useFetchInvoiceItems(props.invoice.id!);

    const currentInvoiceItems = computed(() => invoiceItems.value);
    const taxes = useTaxTextVisuals(currentInvoiceItems);

    return {
      PaymentPlanAmountTypeEnum,
      InvoiceStateEnum,
      dialog,
      deleteDialog,
      selectedInvoiceItem,
      taxes,
      openInvoiceItemDialog,
      openDeleteInvoiceItemDialog,
      removeInvoiceItem,
      clearAllErrors,
      closeDialog,
      invoiceItems,
      isFetchLoading,
      fetchError,
      deleteInProgress,
      deleteError
    };
  }
});
